import { ActionCard } from '@playbooks/core/src/interfaces/ActionCard'

import isConditionSatisfied from '../isConditionSatisfied'
import { ITagConditionEntity, ActionCardModel, BaseNode } from '../actionCard'
import { sectionTypes } from '@playbooks/core/src/constants'

export function checkNodeVisibility(node: BaseNode, actionCardSource?: ActionCardModel | ActionCard): boolean {
  const hierarchy = [node]

  // map all ancestors of a node to list
  while (hierarchy[0]?.parent) {
    hierarchy.unshift(hierarchy[0].parent)
  }

  // node if visible only if it and all its ancestors are visible
  return hierarchy.every(x => {
    return checkVisibility(x?.data, actionCardSource)
  })
}

export function checkVisibility(
  data: any | null | undefined,
  actionCardSource?: ActionCardModel | ActionCard,
): boolean {
  const tagConditionEntity = (data ?? {}) as ITagConditionEntity & { type?: sectionTypes }

  if (tagConditionEntity.type === sectionTypes.SEPARATOR) return true

  return isConditionSatisfied(
    tagConditionEntity.tags || null,
    actionCardSource?.conditionalItems ?? [],
    tagConditionEntity.conditionRule || null,
  )
}
